/**
 * @generated SignedSource<<1d903d19b27720365cb6a6b37e70aa8b>>
 * @relayHash 0c480121a587fd805ceb546488d763a5
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0c480121a587fd805ceb546488d763a5

import { ConcreteRequest } from 'relay-runtime';
export type ReferralReason = "APPOINTMENT_POST_REGISTRATION" | "APPOINTMENT_REGISTRATION" | "EMERGENCY_POST_REGISTRATION" | "EMERGENCY_REGISTRATION" | "REFERRAL";
export type ReferredBy = "CARE_PROVIDER" | "MEDGATE" | "SELF";
export type alternativeTriageDrawerChQuery$variables = {
  id: string;
};
export type alternativeTriageDrawerChQuery$data = {
  readonly ch_alternativeTriageById: {
    readonly reason: string;
    readonly timeWindow: {
      readonly alternativeTriage: boolean | null;
      readonly alternativeTriageEntry: {
        readonly id: string;
        readonly phoneNumber: string;
        readonly reason: string;
      } | null;
      readonly createdAt: string;
      readonly createdBy: string | null;
      readonly dateFrom: any;
      readonly dateTo: any;
      readonly errorCorrection: boolean | null;
      readonly id: string;
      readonly internalComment: string | null;
      readonly involvesPreventionProgram: boolean;
      readonly progressNoteId: string | null;
      readonly referenceDate: any | null;
      readonly referralReason: ReferralReason;
      readonly referralToCareProvider: {
        readonly id: string;
      } | null;
      readonly referralToCareProviderId: string | null;
      readonly referralToDoctorName: string | null;
      readonly referredBy: ReferredBy;
      readonly referredByExternalCareProviderId: string | null;
      readonly updatedAt: string | null;
      readonly updatedBy: string | null;
    } | null;
    readonly timeWindowId: string | null;
  } | null;
};
export type alternativeTriageDrawerChQuery = {
  response: alternativeTriageDrawerChQuery$data;
  variables: alternativeTriageDrawerChQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reason",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeWindowId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "ch_TimeWindow",
  "kind": "LinkedField",
  "name": "timeWindow",
  "plural": false,
  "selections": [
    (v4/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dateFrom",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dateTo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "referralReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "referredBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "referralToCareProviderId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CareProvider",
      "kind": "LinkedField",
      "name": "referralToCareProvider",
      "plural": false,
      "selections": [
        (v4/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "referralToDoctorName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "internalComment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "referredByExternalCareProviderId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "progressNoteId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "errorCorrection",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "referenceDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alternativeTriage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "involvesPreventionProgram",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ch_AlternativeTriage",
      "kind": "LinkedField",
      "name": "alternativeTriageEntry",
      "plural": false,
      "selections": [
        (v4/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneNumber",
          "storageKey": null
        },
        (v2/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "alternativeTriageDrawerChQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ch_AlternativeTriage",
        "kind": "LinkedField",
        "name": "ch_alternativeTriageById",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v5/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "alternativeTriageDrawerChQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ch_AlternativeTriage",
        "kind": "LinkedField",
        "name": "ch_alternativeTriageById",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v5/*:: as any*/),
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "0c480121a587fd805ceb546488d763a5",
    "metadata": {},
    "name": "alternativeTriageDrawerChQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0d4f5020f26de76b179862bd90912f52";

export default node;
